import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '../../ui/Layout';

import BrowseFiles from './BrowseFiles';
import UploadFile from './UploadFile';

export default ({ match }) => (
  <Layout route="files">
    <Switch>
      <Route exact path={`${match.url}`} component={BrowseFiles} />
      <Route exact path={`${match.url}/upload`} component={UploadFile} />
    </Switch>
  </Layout>
);



// WEBPACK FOOTER //
// ./src/components/routes/files/Files.js